import { useRef } from 'react';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  const scrollRef = useRef<HTMLDivElement>(null);

  const scroll = (direction: 'left' | 'right') => {
    if (scrollRef.current) {
      const scrollAmount = 320;
      scrollRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth',
      });
    }
  };

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              Browse by <span className="text-primary-500">Category</span>
            </h2>
            <p className="mt-2 text-sm text-foreground-500">Organized product finds across 14 categories</p>
          </div>
          <span className="hidden md:inline-flex items-center px-3 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold">
            14 Categories
          </span>
        </div>

        <div className="relative">
          <button
            onClick={() => scroll('left')}
            className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-3 z-10 w-10 h-10 flex items-center justify-center rounded-full bg-background-50 border border-background-200/70 text-foreground-600 hover:text-foreground-950 hover:border-foreground-300 transition-all cursor-pointer"
          >
            <i className="ri-arrow-left-s-line text-lg"></i>
          </button>

          <div
            ref={scrollRef}
            className="flex gap-5 overflow-x-auto pb-2"
            style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
          >
            {categories.map((cat) => (
              <a
                key={cat.id}
                href={cat.url}
                target="_blank"
                rel="noopener nofollow"
                className="flex-shrink-0 w-[260px] group cursor-pointer"
              >
                <div className="bg-background-50 rounded-2xl overflow-hidden border border-background-200/50 hover:border-primary-200 transition-all duration-300">
                  <div className="relative h-40 bg-gradient-to-br from-background-100 to-background-200 flex items-center justify-center overflow-hidden">
                    <img
                      src={cat.imageUrl}
                      alt={cat.name}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      loading="lazy"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-background-50/30 to-transparent"></div>
                  </div>
                  <div className="p-4 flex items-center justify-between">
                    <div>
                      <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">
                        {cat.name}
                      </h3>
                      <p className="text-xs text-foreground-400 mt-0.5">{cat.count} finds</p>
                    </div>
                    <div className="w-8 h-8 flex items-center justify-center rounded-full bg-background-100 group-hover:bg-primary-50 transition-colors">
                      <i className={`${cat.icon} text-sm text-foreground-500 group-hover:text-primary-500 transition-colors`}></i>
                    </div>
                  </div>
                </div>
              </a>
            ))}
          </div>

          <button
            onClick={() => scroll('right')}
            className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-3 z-10 w-10 h-10 flex items-center justify-center rounded-full bg-background-50 border border-background-200/70 text-foreground-600 hover:text-foreground-950 hover:border-foreground-300 transition-all cursor-pointer"
          >
            <i className="ri-arrow-right-s-line text-lg"></i>
          </button>
        </div>
      </div>
    </section>
  );
}